import { Dna } from "react-loader-spinner";
const Loader = () => {

    return (
        <div className="loader-container">
            {/* <Bars
                height="80"
                width="80"
                color="#4fa94d"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            /> */}
            {/* <InfinitySpin
                width='200'
                color="#4fa94d"
            /> */}
            <Dna
                visible={true}
                height="80"
                width="80"
                ariaLabel="dna-loading"
                wrapperStyle={{}}
                wrapperClass="dna-wrapper"
            />
        </div>


    );
}
export default Loader;
